import React, { useLayoutEffect, useState, useRef, useContext } from 'react'
import AlertsComp from '../../../Components/AlertsComp';
import LoadingBar from 'react-top-loading-bar';
import GoogleImportButton from './GoogleImportButton';
import { LogInSchoolID, LogInUserID } from '../../../JS/Common';
import { ApiGetCall, ApiPostCall } from '../../../JS/Connector';
import { GetGoogleAdminData, importGoogleDeviceAPI, PostErrorCall } from './GoogleAutomation';
import { GoogleOAuthProvider } from '@react-oauth/google';
import AlertPopup from '../../../Components/AlertPopup';
import { log } from '../../../JS/Logger';
import useConfig from '../../../Hooks/useConfig';

export default function ImportGoogleDevices() {
    const { primary_text } = useConfig();
    const clientId = process.env.REACT_APP_GoogleClientId;
    const IsGoogleSyncedData = { customer_id: "", processStatus: null, email: "" }
    const [Loader, setLoader] = useState(true);
    const [googlePopup, setGooglePopup] = useState({ popup: false, removeAccount: false })
    const [isGoogleAdminUser, setIsGoogleAdminUser] = useState({ msg: "", flag: false })
    const [NewAlerts, setNewAlerts] = useState("");
    const [IsGoogleSynced, setIsGoogleSynced] = useState(IsGoogleSyncedData);
    const refForGoogleImport = useRef(null);

    useLayoutEffect(() => {
        fetchGetGoogleEmailDetails();
    }, []);
    const fetchGetGoogleEmailDetails = async () => {
        setLoader(true)
        try {
            const result = await ApiGetCall(`/google/email-details?schoolId=${LogInSchoolID}`);
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                if (responseRs?.response == "success") {
                    setIsGoogleSynced({ customer_id: responseRs?.data?.customer_id, processStatus: responseRs?.data?.process_status, email: responseRs?.data?.email })
                } else {
                    setIsGoogleSynced(IsGoogleSyncedData)
                }
            }
        } catch (error) {
            log.error("Error fetching data:", error);
        } finally {
            setLoader(false)
        }
    }
    const ImportGoogleDevicesFun = async (status) => {
        const loaderRef = refForGoogleImport.current
        if (loaderRef) {
            loaderRef.continuousStart();
        }
        try {
            setGooglePopup({ ...googlePopup, popup: false })
            try {
                let result = await importGoogleDeviceAPI(IsGoogleSynced, status)
                result = JSON.parse(result)
                if (result?.response == "success") {
                    status == "Add" && fetchGetGoogleEmailDetails()
                    alert("success", result?.message, status == "Update")
                } else {
                    alert("danger", result?.message)
                }
            } catch (error) {
                throw error
            }

        } catch (error) {
            log.error('Error:', error.message);
            try {
                let ErrorResultTwo = await PostErrorCall(error.message, "ImportGoogleDevices_Frontend")
                log.error(ErrorResultTwo)
            } catch (error) {
                log.error(error.message)
            }
            alert("danger", error.message)
        } finally {
            if (loaderRef) {
                loaderRef.complete();
            }
        }

    };
    const onSuccess = async (response) => {

        const loaderRef = refForGoogleImport.current
        if (loaderRef) {
            loaderRef.continuousStart();
        }
        setGooglePopup({ ...googlePopup, popup: true });
        setIsGoogleAdminUser({ ...isGoogleAdminUser, msg: "Are you about to add Google devices to your account?", flag: true });
        setIsGoogleSynced(prev => ({ ...prev, code: response.code }));
    }

    const removeAccountFunction = async () => {
        var raw = JSON.stringify({
            schoolId: LogInSchoolID
        });
        await ApiPostCall("/google/accounts/remove", raw)
            .then(result => {
                if (result == "success") {
                    fetchGetGoogleEmailDetails()
                    setIsGoogleSynced(IsGoogleSyncedData)
                    alert("success", 'Google account removed successfully')
                } else {
                    alert("danger", result)
                }
            })
            .catch(error => {
                log.error('Error', error)
                alert("danger", error.message)
            });
        setGooglePopup({ popup: false, removeAccount: false })
    }
    const alert = (flag, message, redirect = false) => {
        setNewAlerts(<AlertsComp show={true} variant={flag} msg={message} />);
        setTimeout(() => {
            setNewAlerts(<AlertsComp show={false} />);
            if (redirect) window.location = "/manage-device";
        }, 2000);
    }
    return (
        <React.Fragment>
            {NewAlerts}
            <div className='d-flex align-items-center p-1 justify-content-between'>
                <div className='GridTitle pb-2'>Import Your Google Devices</div>
                <div className=""><img src="/images/GoogleBtn.svg" className="img-fluid pe-2" /></div>
            </div>
            <hr className='my-0' />
            <div className="mt-3 mb-2">
                <p className="text-justify" style={{ fontSize: "13px" }}>
                    Connect your Google console account and import your Devices to {primary_text}.
                </p>
            </div>
            <div className='row'>
                {Loader ?
                    <div className='row'>
                        <div className="col-12 text-center pt-2">
                            <img src="/images/loder.svg" className="" style={{ width: "40px" }} />
                        </div>
                    </div> :
                    IsGoogleSynced?.processStatus == 1 ? <>
                        <div className='col-md-12'>
                            Your Google account is syncing with - <span style={{ fontWeight: "600" }}>{IsGoogleSynced?.email}</span>
                        </div>
                        <div className='col-md-12 fw-600 mt-3'>
                            Please wait, data fetching has been initiated in the background. Once the process is completed, you will be notified via email.
                        </div>
                    </>
                        : IsGoogleSynced?.processStatus == 2 ? <>
                            <div className='col-md-12'>
                                Your Google account synced with - <span style={{ fontWeight: "600" }}>{IsGoogleSynced?.email}</span>
                            </div>
                            <div className='col-md-12 mt-3'>
                                <div className="row">
                                    <div className="col-12 mb-3">
                                        <GoogleOAuthProvider clientId={clientId}>
                                            <GoogleImportButton onSuccess={onSuccess} text={`Sync your google devices`} />
                                        </GoogleOAuthProvider>
                                    </div>
                                    <div className="col-12"><button type="button" className="btn btn-danger w-100 h-100 remove-google-button" onClick={() => { setGooglePopup({ popup: true, removeAccount: true }) }}><img src="/images/delete-user.svg" className="img-fluid pe-2" />Remove you google admin account</button></div>
                                </div>
                            </div>
                        </> : <div className='col-md-12 pe-4'>
                            <GoogleOAuthProvider clientId={clientId}>
                                <GoogleImportButton onSuccess={onSuccess} text={`Import your google devices`} />
                            </GoogleOAuthProvider>
                        </div>}
            </div>
            <div className="mt-2 position-relative">
                <LoadingBar style={{ borderRadius: "6px" }}
                    ref={refForGoogleImport}
                    containerClassName='progressbarClass CustomProgressbar' />
            </div>
            <AlertPopup isshow={googlePopup?.popup} img={'/images/greenInfo.svg'}
                headingtext={!googlePopup?.removeAccount ? isGoogleAdminUser?.msg : 'Are you sure you want to remove your Google account?'}
                text={!googlePopup?.removeAccount && 'Duplicate records will be skipped!'}
                cancelcall={(e) => !googlePopup?.removeAccount ? setGooglePopup({ ...googlePopup, popup: false }) : setGooglePopup({ popup: false, removeAccount: false })}
                canceltext={!googlePopup?.removeAccount ? isGoogleAdminUser?.flag ? "No" : "Back" : 'Back'}
                successtext={"Continue"} successcall={(e) => !googlePopup?.removeAccount ? isGoogleAdminUser?.flag && ImportGoogleDevicesFun(IsGoogleSynced?.processStatus == 2 ? "Update" : "Add") : removeAccountFunction()}
                btntype={'SaveBtn'} />
        </React.Fragment >
    )
}

